import { Utils } from 'mw-style-react';
import AppUtils from '@control-front-end/utils/utils';
import {
  VAR_PATTERN,
  URL_REGEXP,
} from '@control-front-end/common/constants/regExp';
import FIELDS, { REQUIRED, ALIGN, VISIBILITY, EDIT_TYPE } from './Fields';

// Строковые поля в которых могут быть переменные
const align = { ...ALIGN };
const opt = align.options.slice();
// Добавляем еще типы для align из других items
opt.push({ value: 'horizontal' }, { value: 'vertical' });
align.options = opt;
const _VAR_STR_FIELDS_ = {
  required: REQUIRED,
  align,
  visibility: VISIBILITY,
  type: EDIT_TYPE,
};

/**
 * Получить доступные поля для item
 * @param item
 * @returns {[]}
 */
export function getItemAvailableFields(item) {
  let exFields = [];
  const className = item.class;
  const itemFields = FIELDS[className];
  Object.keys(itemFields).forEach((i) => {
    exFields = exFields.concat(itemFields[i].map((f) => f.id));
  });
  return exFields;
}

/**
 * Перевести строку в вид переменной
 * @param value
 * @returns {string|makeVar.props}
 * @private
 */
function makeVar(value) {
  if (!value || typeof value !== 'string') return;
  const regExp = new RegExp(VAR_PATTERN);
  if (regExp.test(value)) return value;
  value = value.replace(/{/g, '').replace(/}/g, '');
  value = value || 'var';
  return `{{${value}}}`;
}

/**
 * Установить переменные полям
 * @param item
 */
function setItemVar(item) {
  Object.keys(_VAR_STR_FIELDS_).forEach((prop) => {
    const value = item[prop] || '';
    const itemDescr = _VAR_STR_FIELDS_[prop];
    const itemOpt = itemDescr.options
      .map((i) => i.value)
      .filter((i) => i !== 'variable');
    if (!itemOpt.includes(value.toString())) {
      item[prop] = makeVar(value);
    }
  });
}

/**
 * Установить переменные полям
 * @param form
 * @param activeSection
 */
function setSecTemplateVar(form, activeSection) {
  const section = form.sections[activeSection];
  if (typeof section.loop === 'undefined') return;
  section.loop = makeVar(section.loop);
}

/**
 * Установить поле title
 * @param item
 * @param activeItem
 */
function setTitleField(item, activeItem) {
  const exFields = getItemAvailableFields(item);
  if (exFields.includes('title') && !item.title) {
    item.title = `Title ${activeItem + 1}`;
  }
}

/**
 * Установить поле id
 * @param item
 */
function setIdField(item) {
  if (!item.id) item.id = `item_${AppUtils.udid()}`;
}

/**
 * Установить поле options
 * @param item
 */
function setOptionField(item) {
  const exFields = getItemAvailableFields(item);
  if (!exFields.includes('options')) return;
  const options = item.options || [];
  if (typeof options !== 'string') {
    options.forEach((i, index) => {
      if (!i.title) i.title = `Option ${index + 1}`;
    });
    if (!options.length) {
      options.push({ value: AppUtils.createRid(), title: 'Option 1' });
      item.options = options;
    }
  } else {
    item.options = makeVar(options);
  }
}

/**
 * Установить поле extra
 * @param item
 */
function setExtraField(item) {
  const exFields = getItemAvailableFields(item);
  if (!exFields.includes('extra')) return;
  if (typeof item.extra === 'string') {
    item.extra = makeVar(item.extra);
  }
}

/**
 * Установить поле value для элементов ссылок
 * @param item
 */
function setLinkValue(item) {
  const linkClasses = ['image', 'link'];
  const { class: className, value } = item;
  if (!linkClasses.includes(className)) return;
  const regExp = new RegExp(VAR_PATTERN);
  if (regExp.test(value)) return;
  const urlReg = new RegExp(URL_REGEXP);
  if (!urlReg.test(value)) item.value = '';
}

/**
 * Установить поле value
 * @param item
 * @param activeItem
 */
function setValueField(item, activeItem) {
  const valueClasses = ['label'];
  const { class: className, value } = item;
  if (!valueClasses.includes(className)) return;
  if (!value) return `${Utils.capitalize(className)} ${activeItem + 1}`;
}

/**
 * Установить полям значения по умолчанию
 * @param form
 * @param activeSection
 * @param activeItem
 * @returns {*}
 */
export function setDefaultValue({ form, activeSection, activeItem }) {
  const section = form.sections[activeSection];
  const item = { ...section.content[activeItem] };
  // Установить переменные полям
  setItemVar(item);
  // Установить переменную loop
  setSecTemplateVar(form, activeSection);
  // Установить поле ID
  setIdField(item);
  // Установить поле title
  setTitleField(item, activeItem);
  // Установить поле options
  setOptionField(item);
  // Установить поле extra
  setExtraField(item);
  // Установить поле value для item с ссылками в value
  setLinkValue(item);
  // Установить value
  setValueField(item, activeItem);
  // Удалить ошибки из item
  delete item.errors;
  section.content.splice(activeItem, 1, item);
  return form;
}
